<template>
  <layout title="Sommer" :banner="$page.props.banner" h1="Sommer" metaDescription="In unseren beiden SCOL Hotels in Kals und Fügen genießt du auch im Sommer einen entspannten Aktivurlaub in den Bergen Österreichs."
    metaKeywords="SCOL, SCOL Sommer, Sommerurlaub Österreich, Aktivurlaub Berge, Wandern Österreich, SCOL Hotels, Kals, Fügen, Zillertal, Großglockner">
    <!--
      Bereich „Angebote“ wurde inhaltlich auf „Sommer“ umgestellt (Stand 06/2026).
      „Party on Snow“ und „Osterspecials“ sind entfernt; „Sommer in den Bergen“
      steht jetzt an oberster Stelle. Route/Pfad (/angebote, route 'offer') sowie
      die Section-id (#angebote) bleiben unverändert, damit bestehende Links/SEO
      und das zugehörige CSS (#angebote .inner-text .logos img) erhalten bleiben.
    -->
    <section id="angebote" class="scol-section">
      <div class="bg-light py-4 py-md-5 py-lg-6">
        <div class="container-md">
          <div class="row g-0 align-items-md-center justify-md-center">
            <div class="col-md-6 p-0 overlay-left order-2 order-md-1">
              <div class="inner-text inner-left bg-primary-opactiy">
                <!-- <h2>Shorties</h2>
                <p class="my-3">
                  „kurz mal raus?“ – dann sind unsere Shorties genau das richtige
                </p>

                <p class="mb-0">Shorties</p>
                <a class="link-offer" href="/urlaubsziele/FUEGEN#shorties">Fügen 07.03., 04.04., 11.04., 15.04.</a>
                <a class="link-offer" href="/urlaubsziele/KALS#shorties">Kals 04.04., 11.04., 15.04.</a>

                <p class="mt-3">Bucht euch gleich euren Platz!</p> -->

                <h2>Sommer in den Bergen</h2>
                <p class="my-3">
                  Wunderschöne Landschaft, atemberaubende Ausblicke und
                  unendliche Möglichkeiten für Aktivitäten. Die Berge locken
                  auch im Sommer! In unseren beiden SCOL Hotels (Kals & Fügen)
                  könnt ihr aktiv entspannen! Hier gehts in die Berge:
                </p>
                <a class="d-flex logos align-items-center" href="https://scol-hotel-zillertal.at/" target="_blank">
                  <img class="me-2" src="images/logo-scol-sporthotel-zillertal.svg" alt="Logo SCOL Sporthotel Fügen im Zillertal" />
                  Fügen im Zillertal
                </a>
                <a class="mt-4 d-flex logos align-items-center" href="https://scol-sporthotel.com/" target="_blank">
                  <img class="me-2" src="images/logo-scol-sporthotel-grossglockner.svg" alt="Logo SCOL Sporthotel Kals am Großglockner" />
                  Kals am Großglockner
                </a>
              </div>
            </div>
            <div class="col-md-6 p-0 order-1 order-md-2">
              <div class="inner-image inner-right">
                <!-- <img class="img-fluid w-100" src="/images/scol-skireisen-angebote-teaser.jpg" alt="SCOL Skireisen Gruppenleiter" /> -->

                <img class="img-fluid w-100" src="/images/scol-skireisen-angebote-teaser-fuegen-kals.jpg" alt="Katalog Deckblatt SCOL Skireisen" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="bg-white py-4 py-md-5 py-lg-6">
        <div class="container-md">
          <div class="row g-0 align-items-md-center justify-md-center">
            <div class="col-md-6 p-0">
              <div class="inner-image inner-left">
                <img class="img-fluid w-100" src="/images/scol-skireisen-angebote-teaser-fuegen-kals.jpg" alt="Katalog Deckblatt SCOL Skireisen" />
              </div>
            </div>
            <div class="col-md-6 p-0 overlay-right">
              <div class="inner-text inner-right bg-primary-opactiy">
                <h2>Sommer in den Bergen</h2>
                <p class="my-3">
                  Wunderschöne Landschaft, atemberaubende Ausblicke und
                  unendliche Möglichkeiten für Aktivitäten. Die Berge locken
                  auch im Sommer! In unseren beiden SCOL Hotels (Kals & Fügen)
                  könnt ihr aktiv entspannen! Hier gehts in die Berge:
                </p>
                <a class="d-flex logos align-items-center" href="https://scol-hotel-zillertal.at/" target="_blank">
                  <img class="me-2" src="images/logo-scol-sporthotel-zillertal.svg" alt="Logo SCOL Sporthotel Fügen im Zillertal" />
                  Fügen im Zillertal
                </a>
                <a class="mt-4 d-flex logos align-items-center" href="https://scol-sporthotel.com/" target="_blank">
                  <img class="me-2" src="images/logo-scol-sporthotel-grossglockner.svg" alt="Logo SCOL Sporthotel Kals am Großglockner" />
                  Kals am Großglockner
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </section>
  </layout>
</template>





<script>
import Layout from "./Layouts/Standard";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    info: {
      itemsToShow: 2,
      snapAlign: "start",
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    },
    galerie: {
      itemsToShow: 3,
      wrapAround: true,
      snapAlign: "start",
      arrows: true,
    },
  }),
};
</script>
